<template>
  <div class="flex-vertical flex-between">
    <div>
      <p class="contact_item--type">{{ roleString }}{{ contactTypeString ? " | " + contactTypeString : "" }}</p>
      <button-link
        class="contact_item--name"
        @click="editContact"
      >{{ name }}
      </button-link>

      <p class="contact_item--tags">Tags: {{ contactTagsString ? contactTagsString : 'none' }}</p>

      <p v-if="contact.email_address" class="contact_item--details">
        <sensitive-data-wrapper>
          <template v-if="!contact.is_mailable">
            <del>{{ contact.email_address }}</del>
            <small>(DNC)</small></template>
          <template v-else>{{ contact.email_address }}</template>
        </sensitive-data-wrapper>
      </p>
      <p v-else class="contact_item--details has-text-light"><em>no email address</em></p>
      <p v-if="contact.phone_1" class="contact_item--details">
        <sensitive-data-wrapper>
          <template v-if="contact.is_phone_one_on_do_not_contact_list">
            <del>{{ $utils.formatNumber(contact.phone_1) }}</del>
            <small>(DNC)</small></template>
          <template v-else>{{ $utils.formatNumber(contact.phone_1) }}</template>
        </sensitive-data-wrapper>
      </p>
      <p v-else class="contact_item--details has-text-light"><em>no primary phone</em></p>
    </div>

    <div class="contact_item--icons flex flex-vertical-center flex-between">
      <comm-buttons
        :contact="contact"
        :record="record"
      ></comm-buttons>

      <button-icon
        icon="edit"
        color="is-secondary"
        title="Edit relationship"
        @click="openEditContactLeadRelationship"
      ></button-icon>
    </div>
  </div>
</template>

<script>
import CommButtons from "../../../components/comms/CommButtons";
import router from "../../../router";
import SensitiveDataWrapper from "../../../components/SensitiveDataWrapper.vue";

export default {
  name: "ContactItem",
  components: {
    SensitiveDataWrapper,
    CommButtons,
  },
  props: {
    contact: {
      type: Object,
      required: true
    },
    record: {
      type: Object,
      required: true
    },
    isBuyer: {
      type: Boolean,
      default: false
    },
    isSeller: {
      type: Boolean,
      default: false
    },
    isPrimary: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    };
  },
  computed: {
    name() {
      return this.contact.full_name !== " " ? this.contact.full_name : "Unknown";
    },
    roleString() {
      let roleString = "";

      if (this.isPrimary) roleString += "Primary";
      if (this.isPrimary && (this.isBuyer || this.isSeller)) roleString += " | ";
      if (this.isBuyer) roleString += "Buyer";
      if (this.isSeller) roleString += "Seller";

      return roleString;
    },
    contactTypeString() {
      if (!this.contact.contactContactTypes.length) {
        return null;
      }

      let typeString = "";

      this.contact.contactContactTypes.forEach(type => {
        const contactType = this.$store.getters.contactTypes.find(contactType => contactType.id === type.contact_type_id);

        typeString += contactType.name + ", ";
      });

      return typeString.trim().slice(0, -1);
    },
    contactTagsString() {
      if (!this.contact.tags.length) {
        return null;
      }

      let tagString = "";

      this.contact.tags.forEach(tag => {
        const contactTag = this.$store.getters.contactTags.find(contactTag => contactTag.id === tag.id);

        tagString += contactTag.label + ", ";
      });

      return tagString.trim().slice(0, -1);
    }
  },
  methods: {
    editContact() {
      router.replace({query: {contact: this.contact.id}});
    },
    openEditContactLeadRelationship() {
      this.$emit('edit', this.contact)
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.contact_item {

  &--type {
    font-size: 0.75rem;
    text-transform: uppercase;
    line-height: 1.2;
  }

  &--tags {
    margin-bottom: 6px;
    font-size: 0.75rem;
    line-height: 1.2;
  }

  &--name {
    margin-bottom: 6px;
    font-size: 1.25rem;
    font-weight: bold;
  }

  &--details {
    margin-bottom: 4px;
    font-size: 0.75rem;
  }

  &--icons {
    border-bottom: 1px solid $borderDark;
  }
}
</style>
